export const DRIFT_VISIT_COUNTS = 'visitCounts'

export const LocalStorageItems = [DRIFT_VISIT_COUNTS]
